import Vue from 'vue'
import App from './App.vue'
import router from './router'
import moment from 'moment'
import * as VueGoogleMaps from 'vue2-google-maps'
import store from '@/store'

import 'bootstrap/dist/css/bootstrap.min.css'
import '@/assets/css/main.scss'

Vue.use(store);
Vue.filter('truncate', function(value, length) {
  if(value.length < length) {
    return value;
  }

  length = length - 3;
  return value.substring(0, length) + '...';
});
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(value).format('DD.MM.YYYY')
  }
});

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDMoTG4Cght8HlMnJlgv3tYlxBubfdqLmY',
  },
  installComponents: true
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
